import { TriggerValueType } from "../../../enums/triggerValueType";
import { TriggerValueDto } from "./triggerValueDto";

class FieldValueDto extends TriggerValueDto {
    public valueType: TriggerValueType = TriggerValueType.Field;

    public fieldId: string;
}

export { FieldValueDto }